"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFilterNow = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const DateTimeFilterNow = (props) => {
    const { text, BoxProps, ...rest } = props;
    return (react_1.default.createElement(Box_1.default, { pt: 1, width: 450, display: "flex", justifyContent: "center", ...BoxProps },
        react_1.default.createElement(Button_1.default, { variant: "outlined", ...rest }, text)));
};
exports.DateTimeFilterNow = DateTimeFilterNow;
exports.default = exports.DateTimeFilterNow;
